document.addEventListener('DOMContentLoaded', function () {

  // // Watch for when components are added to the DOM
  // const observer = new MutationObserver(mutations => {
  //   mutations.forEach(mutation => {
  //     mutation.addedNodes.forEach(node => {
  //       // Check if this is our component or contains our component
  //       if (node.nodeName?.toLowerCase() === 'spark-product-card' || node.querySelector?.('spark-product-card')) {
  //         const cards = node.nodeName?.toLowerCase() === 'spark-product-card' ? [node] : node.querySelectorAll('spark-product-card');
  //         console.log(cards);
  //         cards.forEach(card => {
  //           // Wait for shadow DOM to be created
  //           if (card.shadowRoot) {
  //             applyStyling(card.shadowRoot);
  //           } else {
  //             // Check again after a short delay
  //             setTimeout(() => {
  //               if (card.shadowRoot) applyStyling(card.shadowRoot);
  //             }, 100);
  //           }
  //         });
  //       }
  //     });
  //   });
  // });
  
  // function applyStyling(shadowRoot) {
  //   const stockStatus = shadowRoot.querySelector('.product-card-stock-status');
  //   if (stockStatus) stockStatus.style.display = 'none'; // or whatever value
  //   console.log(stockStatus.style.display);
  // }
  
  // // Start observing
  // observer.observe(document.body, { childList: true, subtree: true });

  // console.log("SL Badge Updater loaded");
})